module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/kitchen-dialog/kitchen-dialog.component.scss
// module id = 1208
// module chunks = 0